import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: 'CompanyInfoModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '厂商信息表单',
      tableName: 'ea_company_info',
      form_fields: ['code', 'name', 'category', 'contacts', 'post', 'tel', 'email', 'serviceTel', 'legal', 'taxName', 'taxCode', 'addr', 'remark', 'sort'],
      form_fields_time: [],
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入厂商名称!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入厂商类别!'
          }]
        },
        contacts: {
          rules: [{
            required: true,
            message: '请输入联系人!'
          }]
        } // sort: { rules: [{ required: true, message: '请输入排序号!' }] },

      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          }); //debugger
          //console.log(formData)

          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};